import React, {useEffect, useState} from 'react';
import {useAuthorizationStateValue} from "../../../account/context";
import {useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import keys from "../../../common/keys";
import {startRegistration} from "../../../account/account.service";
import {getBrowserName} from "../../../common/util";

const RegistracijaEmail= (props) => {
    const {register, handleSubmit, setValue, getValues} = useForm();
    const [inputInvalid, setInputInvalid] = useState(true);
    const [isLoading,setLoading] = useState(false);
    const [invalidSubmit, setInvalidSubmit] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const {isAuthorized, tokenData} = useAuthorizationStateValue();

    let navigate = useNavigate();

    useEffect(() => {
        return async () => {
            let regStep = await sessionStorage.getItem(keys.MTEL_ID_REG_STEP);
            if(!regStep || (regStep!="1"&& regStep!="2")) {
                navigate('/kreiraj-nalog');
            }
            sessionStorage.setItem(keys.MTEL_ID_REG_STEP,"2");
        };
    }, []);

    const onInputChangeValue = (event) => {
        setInvalidSubmit(false);
        setValue(event.target.name, event.target.value);
        if (getValues("email").length > 0) setInputInvalid(false);
        else setInputInvalid(true);
    };

    const onSubmit = async (data) => {
        if (inputInvalid) return;
        if(isLoading) return;

        let username = data.email;

        let isPhoneNumber = true;

        setLoading(true);
        try {
            const response = await startRegistration({
                username: data.email,
                deviceType: "PHONE",
                deviceUsername: data.email,
                osType: 1, //TODO CHECK, android for some reason....
                registrationType: "EMAIL",
                devicePassword: localStorage.getItem(keys.MTEL_ID_DEVICE_ID),
                deviceName: getBrowserName(),
            });
            if (response) {
                await sessionStorage.setItem(keys.MTEL_ID_REG_GUID, response.data);
                await sessionStorage.setItem(keys.MTEL_ID_REG_USERNAME, username)
                setLoading(false);
                navigate('/kreiraj-nalog/potvrdi-e-mail');
            }
        }catch (e){
            if (e.response.data?.message) {
                setErrorMessage(e.response.data.message);
            }
            setInvalidSubmit(true);
            setLoading(false);
        }
    }

    return (
        <div id="registerPagePhoneNumber" className="lightContent center">
            <div className="wizardCenterArea">
                <div className="mainTitle spacer spacerUp">Registruj se <span className="mainTileAdditional">> Unesi E-mail</span></div>
                <div className="standardText">Unesi svoju e-mail adresu kako bi proces registracije započeo. Nakon toga, biće ti poslata e-mail poruka sa jednokratnim aktivacionim kodom koji trebaš unijeti da bi se nastavio proces registracije.
                </div>
                <form onSubmit={handleSubmit(onSubmit)} noValidate="novalidate">
                    <div className="standardInputWrapper">
                        <label>E-mail</label>
                        <input {...register("email")} className="full" type="text" name="email" onChange={onInputChangeValue} required/><i className="fa fa-envelope fa-lg"></i>
                    </div>
                    <div className={"validationErrorMessage"+(invalidSubmit ? " invalid" : "")}><i className="fa fa-warning"></i> {errorMessage}</div>
                    <div className="centerWrapper">
                    <input className={"mainActionButton center" + (inputInvalid ? " invalid" : "")+(isLoading ? " loading" : "")} type="submit"
                           value={"Nastavi"}/>
                    </div>
                </form>
            </div>

        </div>
    );

}

export default RegistracijaEmail;